import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  ChatLock,
  Message,
  MessageCategory,
  MessageListResponse,
  MessageThreadResponse,
  SendMessageRequest,
  MESSAGING_CONFIG,
} from '../../../../util/src/index';

export class MessagesEndpoint {
  private readonly config = inject(MESSAGING_CONFIG);
  private readonly http = inject(HttpClient);

  get(params: Record<string, string> = {}): Observable<MessageListResponse> {
    return this.http.get<MessageListResponse>(`${this.config.baseUrl}/admin/messages`, { params });
  }

  post(body: SendMessageRequest): Observable<Message> {
    return this.http.post<Message>(`${this.config.baseUrl}/messages`, body);
  }
}

export class MessageEndpoint {
  private readonly config = inject(MESSAGING_CONFIG);
  private readonly http = inject(HttpClient);

  put(messageId: number, body: Record<string, unknown>): Observable<void> {
    return this.http.put<void>(`${this.config.baseUrl}/admin/messages/${messageId}/`, body);
  }
}

export class PatientMessagesEndpoint {
  private readonly config = inject(MESSAGING_CONFIG);
  private readonly http = inject(HttpClient);

  get(patientId: number, params: Record<string, string> = {}): Observable<MessageThreadResponse> {
    return this.http.get<MessageThreadResponse>(
      `${this.config.baseUrl}/admin/users/${patientId}/messages`,
      { params },
    );
  }

  put(body: { user_id: number; message_id?: number }): Observable<void> {
    return this.http.put<void>(`${this.config.baseUrl}/messages/thread/seen`, body);
  }
}

export class MessageCategoriesEndpoint {
  private readonly config = inject(MESSAGING_CONFIG);
  private readonly http = inject(HttpClient);

  get(): Observable<MessageCategory[]> {
    return this.http.get<MessageCategory[]>(`${this.config.baseUrl}/admin/messages/categories/`);
  }
}

export class MessageLockEndpoint {
  private readonly config = inject(MESSAGING_CONFIG);
  private readonly http = inject(HttpClient);

  get(patientId: number): Observable<ChatLock> {
    return this.http.get<ChatLock>(`${this.config.baseUrl}/admin/users/${patientId}/messages/lock`);
  }

  post(patientId: number): Observable<void> {
    return this.http.post<void>(`${this.config.baseUrl}/admin/users/${patientId}/messages/lock`, {});
  }
}
